import { Col, Form, Row } from "antd";
import { useWatch } from "antd/lib/form/Form";
import React from "react";
import InputNumber from "../../../../components/atoms/InputNumber";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import { RenderInputProps } from "../../Interface";

const { Item } = Form;
const SimultaneosVehicleCountInputs: React.FC<RenderInputProps> = ({
  form,
}) => {
  const maximumSimultaneouslyVehicleCount = useWatch(
    ["repairShopBusiness", "maximumSimultaneouslyVehicleCount"],
    form
  );
  return (
    <Row gutter={[0, 12]} align="middle">
      <Col span={24}>
        <ExplainWrapper
          status={
            !maximumSimultaneouslyVehicleCount &&
            form.getFieldError([
              "repairShopBusiness",
              "maximumSimultaneouslyVehicleCount",
            ]).length > 0
              ? { status: "error", explain: "필수 값입니다" }
              : undefined
          }
        >
          <Row align="middle" gutter={[12, 0]} wrap={false}>
            <Col
              flex="0 0 100px"
              style={{ overflow: "hidden", whiteSpace: "nowrap" }}
            >
              최대
            </Col>
            <Col flex="0 0 200px">
              <Item
                validateTrigger="onChange"
                noStyle
                rules={[{ required: true, message: "필수 값입니다" }]}
                name={[
                  "repairShopBusiness",
                  "maximumSimultaneouslyVehicleCount",
                ]}
              >
                <InputNumber
                  placeholder="동시간대 예약 가능 차량 수"
                  style={{ width: "100%" }}
                  min={1}
                  status={
                    form.getFieldError([
                      "repairShopBusiness",
                      "maximumSimultaneouslyVehicleCount",
                    ]).length > 0
                      ? "error"
                      : undefined
                  }
                  controls={false}
                  max={1000}
                />
              </Item>
            </Col>
            <Col>대</Col>
          </Row>
        </ExplainWrapper>
      </Col>
    </Row>
  );
};
export default SimultaneosVehicleCountInputs;
